var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_873_1206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3332 0H0.666504V16H27.3332V0Z",
    fill: "#25459A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0354 7.03833C14.0254 7.78125 14.7409 8.19586 15.28 8.44234C15.8339 8.69527 16.0199 8.85744 16.0178 9.08359C16.0136 9.42975 15.576 9.5825 15.1664 9.58845C14.4519 9.59887 14.0365 9.40744 13.7062 9.26262L13.4488 10.3929C13.7801 10.5362 14.3937 10.6612 15.03 10.6666C16.5236 10.6666 17.5008 9.97479 17.506 8.90207C17.5119 7.54072 15.4993 7.46534 15.5131 6.85682C15.5178 6.67233 15.7055 6.47544 16.1166 6.42535C16.3201 6.40006 16.8819 6.38072 17.5187 6.65596L17.7687 5.56242C17.4262 5.44537 16.986 5.33329 16.438 5.33329C15.0321 5.33329 14.0433 6.03455 14.0354 7.03833ZM20.1707 5.42752C19.898 5.42752 19.6681 5.5768 19.5656 5.80592L17.4321 10.5863H18.9245L19.2215 9.81609H21.0454L21.2177 10.5863H22.5331L21.3852 5.42752H20.1707ZM20.3795 6.82111L20.8102 8.75825H19.6306L20.3795 6.82111ZM12.2258 5.42752L11.0494 10.5863L12.4716 10.5863L13.6475 5.42752H12.2258ZM10.1219 5.42752L8.64157 8.93877L8.04278 5.95322C7.97249 5.61995 7.69503 5.42752 7.38692 5.42752H4.96693L4.93311 5.57729C5.42989 5.67847 5.99433 5.84163 6.33626 6.0162C6.54555 6.12283 6.60527 6.21606 6.67397 6.46949L7.80813 10.5863H9.31117L11.6154 5.42752H10.1219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_873_1206"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 26.6667,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9feac0e7f5699498b963f2ae00e56567.svg";
export { ForwardRef as ReactComponent };